import * as React from "react";

export interface IHeroContext {
  hero: boolean;
  setHero: (b: boolean) => void;
}

export const HeroContext = React.createContext<IHeroContext | undefined>(undefined);

export const HeroContextProvider: React.FC = ({ children }) => {
  const [hero, _hero] = React.useState(true);

  const setHero = (b: boolean) => {
    _hero(b);
  };

  return <HeroContext.Provider value={{ hero, setHero }}>{children}</HeroContext.Provider>;
};

export function useHero() {
  const context = React.useContext(HeroContext);
  if (context === undefined) {
    throw new Error("useHero must be used within a HeroContextProvider");
  }
  return context;
}
